import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.06.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema, {strict: false})
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {strictMode, ignoreManifest, isValidTime, getMinTimeStep})

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content) {
  if (content.metadata) {
    const studioMode = content.metadata.studioMode || 'create'
    const lastPlayheadPosition = content.metadata.lastPlayheadPosition || []
    const selectedVisualStyle = content.metadata.selectedVisualStyle
    delete content.metadata.studioMode
    delete content.metadata.lastPlayheadPosition
    delete content.metadata.selectedVisualStyle
    delete content.metadata.isSimpleMode
    delete content.metadata.openedInStudio
    content.metadata.studioSettings = {
      default: {studioMode, lastPlayheadPosition, selectedVisualStyle}
    }
  }
}
